export const GAME_WIDTH = 360;
export const GAME_HEIGHT = 640;
export const PLAYER_Y = 560;
export const INITIAL_PLAYER_X = GAME_WIDTH / 2;
export const INITIAL_PLAYER_Y = PLAYER_Y;
export const SPREAD_BULLET_VX = 145;
export const INITIAL_LIVES = 3;

export const LEVELS = [
  {
    name: 'Sector 1',
    enemyCount: 8,
    spawnRateMs: 980,
    enemyTypes: ['scout'],
    speed: 84,
    movement: 'straight',
  },
  {
    name: 'Sector 2',
    enemyCount: 15,
    spawnRateMs: 900,
    enemyTypes: ['scout', 'raider'],
    speed: 92,
    movement: 'drift',
    waves: [
      {
        pattern: 'formationEntry',
        startMs: 0,
        intervalMs: 360,
        rows: 3,
        lanes: [62, 121, 180, 239, 298],
        enemyTypes: ['scout', 'scout', 'raider', 'scout', 'scout'],
        y: -44,
      },
    ],
  },
  {
    name: 'Sector 3',
    enemyCount: 16,
    spawnRateMs: 820,
    enemyTypes: ['raider'],
    speed: 104,
    movement: 'sine',
    waves: [
      {
        pattern: 'crossfirePair',
        startMs: 0,
        intervalMs: 420,
        pairs: 8,
        leftX: 48,
        rightX: 312,
        y: -36,
        enemyTypes: ['raider'],
      },
    ],
  },
  {
    name: 'Sector 4',
    enemyCount: 21,
    spawnRateMs: 780,
    enemyTypes: ['scout', 'raider', 'heavy'],
    speed: 108,
    movement: 'drift',
    powerupEvery: 3,
    waves: [
      {
        pattern: 'powerupEscort',
        startMs: 0,
        intervalMs: 360,
        escortX: 180,
        lanes: [72, 118, 180, 242, 288],
        repeats: 3,
        delayBetweenRepeatsMs: 2100,
      },
    ],
  },
  {
    name: 'Sector 5',
    enemyCount: 26,
    spawnRateMs: 720,
    enemyTypes: ['raider', 'heavy'],
    speed: 116,
    movement: 'sine',
    special: 'bonusWave',
    goal: 'challenge',
    powerupEvery: 2,
    perfectClearBonus: 600,
    fastClearMs: 14500,
    fastClearBonus: 300,
    waves: [
      {
        pattern: 'formationEntry',
        startMs: 0,
        intervalMs: 260,
        rows: 3,
        lanes: [58, 108, 158, 208, 258, 308],
        enemyTypes: ['scout', 'scout', 'raider', 'raider', 'scout', 'scout'],
        y: -44,
      },
      {
        pattern: 'crossfirePair',
        startMs: 3600,
        intervalMs: 360,
        pairs: 4,
        leftX: 52,
        rightX: 308,
        y: -36,
        enemyTypes: ['raider'],
      },
    ],
  },
  {
    name: 'Sector 6',
    enemyCount: 34,
    spawnRateMs: 680,
    enemyTypes: ['scout', 'heavy'],
    speed: 124,
    movement: 'straight',
    goal: 'survive',
    durationMs: 26000,
    hazards: [
      {
        type: 'meteorLane',
        startMs: 900,
        intervalMs: 1600,
        lanes: [74, 180, 286],
      },
    ],
  },
  {
    name: 'Sector 7',
    enemyCount: 28,
    spawnRateMs: 610,
    enemyTypes: ['raider', 'heavy', 'bomber'],
    speed: 132,
    movement: 'drift',
  },
  {
    name: 'Sector 8',
    enemyCount: 30,
    spawnRateMs: 570,
    enemyTypes: ['scout', 'raider', 'splitter'],
    speed: 140,
    movement: 'sine',
    hazards: [
      {
        type: 'meteorLane',
        startMs: 600,
        intervalMs: 1300,
        lanes: [56, 134, 226, 304],
      },
    ],
  },
  {
    name: 'Sector 9',
    enemyCount: 32,
    spawnRateMs: 540,
    enemyTypes: ['raider', 'heavy', 'bomber', 'splitter'],
    speed: 148,
    movement: 'drift',
  },
  {
    name: 'Sector 10',
    enemyCount: 0,
    spawnRateMs: 520,
    enemyTypes: [],
    speed: 0,
    movement: 'boss',
    boss: {
      name: 'Dread Core',
      health: 84,
      points: 500,
      attackIntervalMs: 980,
      speed: 74,
      phaseThresholds: [0.65, 0.32],
      summonIntervalMs: 1800,
    },
  },
  {
    name: 'Sector 11',
    enemyCount: 34,
    spawnRateMs: 500,
    enemyTypes: ['scout', 'raider', 'splitter'],
    speed: 154,
    movement: 'sine',
  },
  {
    name: 'Sector 12',
    enemyCount: 36,
    spawnRateMs: 460,
    enemyTypes: ['heavy', 'bomber', 'splitter'],
    speed: 160,
    movement: 'drift',
    hazards: [
      {
        type: 'meteorLane',
        startMs: 500,
        intervalMs: 1100,
        lanes: [60, 140, 220, 300],
      },
    ],
  },
  {
    name: 'Sector 13',
    enemyCount: 0,
    spawnRateMs: 440,
    enemyTypes: [],
    speed: 0,
    movement: 'boss',
    boss: {
      id: 'boss-dread-core-prime',
      name: 'Dread Core Prime',
      health: 112,
      points: 900,
      attackIntervalMs: 860,
      speed: 88,
      phaseThresholds: [0.7, 0.36],
      summonIntervalMs: 1600,
    },
  },
  {
    name: 'Sector 14',
    enemyCount: 38,
    spawnRateMs: 450,
    enemyTypes: ['scout', 'raider', 'bomber'],
    speed: 164,
    movement: 'drift',
    hazards: [
      {
        type: 'meteorLane',
        startMs: 700,
        intervalMs: 1050,
        lanes: [64, 128, 232, 296],
      },
    ],
  },
  {
    name: 'Sector 15',
    enemyCount: 0,
    spawnRateMs: 430,
    enemyTypes: [],
    speed: 0,
    movement: 'boss',
    boss: {
      id: 'boss-dread-core-apex',
      name: 'Dread Core Apex',
      health: 128,
      points: 1000,
      attackIntervalMs: 820,
      speed: 90,
      phaseThresholds: [0.7, 0.36],
      summonIntervalMs: 1400,
    },
  },
  {
    name: 'Sector 16',
    enemyCount: 40,
    spawnRateMs: 430,
    enemyTypes: ['raider', 'splitter', 'bomber'],
    speed: 170,
    movement: 'sine',
    hazards: [
      {
        type: 'shieldGate',
        startMs: 900,
        intervalMs: 3100,
        lanes: [94, 180, 266],
      },
    ],
  },
  {
    name: 'Sector 17',
    enemyCount: 42,
    spawnRateMs: 410,
    enemyTypes: ['heavy', 'splitter', 'bomber'],
    speed: 176,
    movement: 'drift',
    hazards: [
      {
        type: 'meteorLane',
        startMs: 600,
        intervalMs: 980,
        lanes: [52, 116, 180, 244, 308],
      },
    ],
  },
  {
    name: 'Sector 18',
    enemyCount: 44,
    spawnRateMs: 390,
    enemyTypes: ['scout', 'raider', 'heavy', 'splitter'],
    speed: 182,
    movement: 'sine',
    goal: 'survive',
    durationMs: 32000,
    hazards: [
      {
        type: 'meteorLane',
        startMs: 500,
        intervalMs: 900,
        lanes: [58, 140, 220, 302],
      },
      {
        type: 'shieldGate',
        startMs: 1800,
        intervalMs: 4200,
        lanes: [112, 248],
      },
    ],
  },
  {
    name: 'Sector 19',
    enemyCount: 46,
    spawnRateMs: 370,
    enemyTypes: ['raider', 'heavy', 'bomber', 'splitter'],
    speed: 188,
    movement: 'drift',
    hazards: [
      {
        type: 'meteorLane',
        startMs: 450,
        intervalMs: 860,
        lanes: [48, 114, 180, 246, 312],
      },
    ],
  },
  {
    name: 'Sector 20',
    enemyCount: 0,
    spawnRateMs: 350,
    enemyTypes: [],
    speed: 0,
    movement: 'boss',
    boss: {
      id: 'boss-dread-core-omega',
      name: 'Dread Core Omega',
      health: 168,
      points: 1400,
      attackIntervalMs: 760,
      speed: 98,
      phaseThresholds: [0.72, 0.38],
      summonIntervalMs: 1200,
    },
  },
];

export const ENEMY_TYPE_CONFIG = {
  scout: {
    health: 1,
    points: 10,
    speedMultiplier: 1.18,
  },
  raider: {
    health: 1,
    points: 20,
    speedMultiplier: 1.05,
    movement: 'sine',
  },
  heavy: {
    health: 3,
    points: 40,
    speedMultiplier: 0.78,
  },
  bomber: {
    health: 2,
    points: 45,
    speedMultiplier: 0.7,
    movement: 'drift',
    hazardIntervalMs: 1700,
  },
  splitter: {
    health: 2,
    points: 35,
    speedMultiplier: 0.92,
    movement: 'sine',
    splitInto: 2,
  },
  splinter: {
    health: 1,
    points: 12,
    speedMultiplier: 1.28,
    movement: 'drift',
  },
};

export const POWERUP_TYPES = [
  'rapidFire',
  'spreadShot',
  'optionDrone',
  'pulseBomb',
  'shield',
  'bonus',
];
